import type { BffApiClient } from "@/app/api-client"
import { getRoyaltyQueryParams } from "@/app/nft/store/get-royalty-query-params"
import { getQueryClient } from "@/app/react-query/query-client"
import type { NftId } from "@anaconda/core/nft/types"

/**
 * Room over the shown royalty, in bps. Rarible reports each creator's share
 * rounded down, so its sum can sit a few bps under the on-chain figure; a cap
 * that tight would refuse honest accepts.
 */
const ROUNDING_ALLOWANCE_BPS = 10

/**
 * The royalty cap for accepting a bid on an item, in bps: what the accept
 * dialog showed, read from the same cached query it rendered. A royalty raised
 * in the meantime reverts the fill instead of taking the seller's proceeds.
 */
export async function getShownRoyaltyBps(
  bffApiClient: BffApiClient,
  itemId: NftId,
): Promise<number> {
  const { royalty } = await getQueryClient().ensureQueryData(
    getRoyaltyQueryParams(bffApiClient, itemId),
  )
  return Math.min(Math.round(royalty * 100) + ROUNDING_ALLOWANCE_BPS, 10_000)
}
